import axios from 'axios'
// 创建一个 axios 实例
const baseurl=''
function GetQueryString(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]); return null;
}
const service = axios.create({
	// baseURL:"http://10.35.65.226:7001/api/",
	baseURL:"http://116.62.105.167:7001/api/",
	// 
	timeout: 60000, // 请求超时时间毫秒
	// withCredentials: true, // 异步请求携带cookie
	headers: {
		// 设置后端需要的传参类型
		// "Accept":"*/*",
		// 'Content-Type': 'application/json',
        // 'Content-Type':'multipart/form-data',
		// 'X-Requested-With': 'XMLHttpRequest',
		// 'X-Requested-With': 'XMLHttpRequest',
		// 'token':JSON.parse(window.localStorage.getItem('userInfo'))?.token|| "",
	},
})

// 添加请求拦截器
service.interceptors.request.use(
	function (config) {
		// // 在发送请求之前做些什么
        // console.log("config", config);
        // console.log("config", config.headers.Accept);
		
		return config
	},
	function (error) {
		// 对请求错误做些什么
		// console.log(error)
		return Promise.reject(error)
	}
)

// 添加响应拦截器
service.interceptors.response.use(
	function (response) {
		console.log(response.data.code)
		if(response.data.code == 100003){
			localStorage.clear()
			// window.location.replace('/login')
		}
		// 2xx 范围内的状态码都会触发该函数。
		// 对响应数据做点什么
		// dataAxios 是 axios 返回数据中的 data
		const dataAxios = response.data
		// 这个状态码是和后端约定的
		const code = dataAxios.reset
		return dataAxios
	},
	function (error) {
		// 超出 2xx 范围的状态码都会触发该函数。
		// 对响应错误做点什么
		if(error.code === 'ECONNABORTED' || error.message ===   "Network Error" ||  error.message.includes("timeout")){  
		  }
		  return Promise.resolve(error.response);
		// return Promise.reject(error)
	}
)
export default service
